PARAM_LOGIN_ASSISTANCE_FORM_ID